import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const LetterIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.3978 4.24478C14.6307 4.09643 14.9398 4.16521 15.0882 4.3981C15.2366 4.631 15.1678 4.94017 14.9349 5.08853L8.94173 8.90591C8.93611 8.90949 8.9299 8.9133 8.92415 8.91665C8.64454 9.07906 8.32659 9.16465 8.00325 9.1647C7.67982 9.1647 7.36203 9.0791 7.08235 8.91665C7.07656 8.91329 7.07042 8.91048 7.06477 8.90689L1.06477 5.08853C0.831857 4.94026 0.763219 4.63105 0.911452 4.3981C1.05972 4.16518 1.36893 4.09654 1.60188 4.24478L7.58723 8.05337C7.71374 8.12625 7.85722 8.1647 8.00325 8.1647C8.14878 8.16465 8.29114 8.1258 8.41731 8.05337L14.3978 4.24478Z"
      fill="currentColor"
    />
    <path
      d="M14.1663 3.99969C14.1662 3.53961 13.7935 3.16669 13.3333 3.16669H2.66634C2.20636 3.16686 1.8335 3.53972 1.83333 3.99969V11.9997C1.83333 12.4598 2.20625 12.8335 2.66634 12.8337H13.3333C13.7936 12.8337 14.1663 12.4599 14.1663 11.9997V3.99969ZM15.1663 11.9997C15.1663 13.0122 14.3459 13.8337 13.3333 13.8337H2.66634C1.65396 13.8335 0.833328 13.0121 0.833328 11.9997V3.99969C0.833504 2.98743 1.65407 2.16686 2.66634 2.16669H13.3333C14.3457 2.16669 15.1662 2.98732 15.1663 3.99969V11.9997Z"
      fill="currentColor"
    />
  </svg>
);
